import React from "react";
import Blogs from "../components/Blogs";
import NavbarBlog from "../Pages/Navbar/NavbarBlog/NavbarBlog";

const Blog = () => {
  return <div>
    <NavbarBlog />
    <Blogs />
  </div>;
};

export default Blog;
